<template>
    <div class="point-container">
        <button type="button" class="point-button" :tabindex="tabIndex" @click="emit('locatePoint', pointOfSale)">
            <div class="map-pin" :class="[isSelected ? 'is-red' : 'is-blue']">
                <span class="map-pin-index">{{ pointOfSale.index }}</span>
            </div>
            <div class="point-infos-container">
                <p class="point-title">
                    <strong v-html="pointOfSale.nom"></strong>
                </p>
                <div class="point-infos-wrapper">
                    <div class="point-infos">
                        <p v-html="pointOfSale.adresse"></p>
                        <div v-if="pointOfSale.accessible === '1'" class="accessible-icon">
                            <span class="visuallyhidden">{{ messages.accessible_point_of_sale }}</span>
                            <img src="@@/img/accessible.svg" width="18" height="18" />
                        </div>
                    </div>
                    <a :href="`tel:${pointOfSale.telephone.replace(/-/g, '')}`" :tabindex="tabIndex">
                        {{ pointOfSale.telephone }}
                    </a>
                </div>
            </div>
        </button>
        <div class="point-buttons-container">
            <form method="get" action="https://www.google.com/maps/" target="google-maps" class="itinerary-form">
                <input :value="pointOfSale.adresse" name="daddr" type="hidden" />
                <button type="submit" class="route-button button" :tabindex="tabIndex">
                    {{ messages.itinerary }}<span class="visuallyhidden">
                        {{ messages.itinerary_to }} {{ pointOfSale.nom }}, {{ pointOfSale.adresse }}</span
                    >
                </button>
                <a v-if="pointOfSale.centre_information === '1'" :href="meta.hours_page" class="button is-outlined" :tabindex="tabIndex">
                    {{ messages.business_hours }}
                </a><BaseLink v-if="pointOfSale.site_web" :href="pointOfSale.site_web" external :icon-size="14" class="button is-outlined" :tabindex="tabIndex">{{ messages.website }}</BaseLink>
            </form>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import BaseLink from '@/shared/BaseLink';

const props = defineProps({
    pointOfSale: {
        type: Object,
        default: () => ({}),
    },
    isSelected: {
        type: Boolean,
        default: false
    },
    messages: {
        type: Object,
        default: () => ({}),
    },
    meta: {
        type: Object,
        default: null
    },
    isHidden: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['locatePoint']);

const tabIndex = computed(() => (props.isHidden ? -1 : 0));
</script>

<style lang="scss" scoped>
.point-container {
    position: relative;
    padding: 16px 0 70px;
    font-family: $body-font-family;
    a[href^='tel:'] {
        @include rem-typo(16px);
        color: $color-black;
    }
}
.point-button {
    @include accessible-focus;
    display: flex;
    align-items: flex-start;
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    cursor: pointer;
    gap: 24px;
    padding: 0;
}
.accessible-icon {
    flex-shrink: 0;
}
.point-title {
    @include rem-typo(18px);
    margin: 0 0 8px 0;
}
.point-infos-container {
    flex-grow: 1;
    width: 100%;
}
.point-infos-wrapper {
    p {
        @include rem-typo(16px);
        margin-bottom: 0;
    }
}
.point-infos {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}
.point-buttons-container {
    position: absolute;
    bottom: 16px;
    left: 54px;
}
.map-pin {
    position: relative;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
    &.is-blue {
        background-image: url('@@/img/blue-map-pin.svg');
        width: 30px;
        height: 42px;
    }
    &.is-red {
        background-image: url('@@/img/red-map-pin.svg');
        width: 34px;
        height: 52px;
    }
}
.map-pin-index {
    position: absolute;
    left: 50%;
    font-family: $body-font-family;
    text-align: center;
    letter-spacing: -0.5px;
    border-radius: 50%;
    transform: translateX(-50%);
    .is-red & {
        @include rem-typo(13px);
        top: 10px;
    }
    .is-blue & {
        @include rem-typo(10px);
        top: 8px;
    }
}
.itinerary-form {
    display: flex;
    gap: 8px;
}
</style>
